export function jumpGoogle(val) {
    let params = [val.platLng.lat, val.platLng.lng]
    window.open('https://www.google.com/maps/dir/?api=1&destination=' + params.toString())
}